const Variant = Object.freeze({
  NAKED: 'naked',
  OUTLINE: 'outline',
  TEXT: 'text',
  CONTAINED: 'contained',
  FLAT: 'flat',
});

export default Variant;
